import InlineEditAutocomplete from '@components/v2/form/InlineEditAutocomplete/InlineEditAutocomplete';
import InlineEditSelect from '@components/v2/form/InlineEditSelect/InlineEditSelect';
import ObjectScreen from '@components/v2/layout/ObjectScreen/ObjectScreen';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../../../../lang/LangEnum';
import { CatalogProductsTestIds } from '../../../../../../../../utils/testIds/CatalogProducts.testIds';
import { Catalog, CatalogNavigationDeliveryWindow } from '../../../../../../catalog.types';
import CatalogDetailField from '../CatalogDetailField';
import CatalogNavigationLockAlert from '../CatalogNavigationLockAlert';
import useCatalogNavigationSection from './hooks/useCatalogNavigationSection';

export type CatalogNavigationSectionProps = Pick<
  Catalog,
  'id' | 'navigationAvailabilities' | 'navigationDeliveryWindows' | 'showUnavailableProductsForSale'
> & {
  isReadOnly: boolean;
};

const CatalogNavigationSection = (props: CatalogNavigationSectionProps) => {
  const {
    isFieldDisabled,
    isNavigationLocked,
    availabilities,
    availabilityOptions,
    deliveryWindows,
    deliveryWindowsLabel,
    deliveryWindowsSource,
    isDeliveryWindowsDisabled,
    submitAvailabilities,
    submitDeliveryWindows,
  } = useCatalogNavigationSection(props);

  return (
    <ObjectScreen.Section
      title={LangEnum.CATALOGS_CREATION_MODAL_SECTION_NAVIGATION_EXPERIENCE}
      isDefaultOpen
      persistKey="catalog-details:navigation"
      alert={isNavigationLocked ? <CatalogNavigationLockAlert /> : undefined}
    >
      <Stack sx={{ gap: 0.75 }}>
        <CatalogDetailField
          width="45%"
          maxWidth="50%"
          label={LangEnum.GLOBAL_AVAILABILITY}
          control={
            <InlineEditSelect
              multiple
              value={availabilities}
              options={availabilityOptions}
              isDisabled={isFieldDisabled}
              testId={CatalogProductsTestIds.DETAILS_NAVIGATION_AVAILABILITIES}
              onConfirm={submitAvailabilities}
            />
          }
        />
        <CatalogDetailField
          width="45%"
          maxWidth="50%"
          label={LangEnum.GLOBAL_DELIVERY_WINDOWS}
          control={
            <InlineEditAutocomplete<CatalogNavigationDeliveryWindow>
              multiple
              value={deliveryWindows.map((deliveryWindow) => deliveryWindow.id)}
              displayLabel={deliveryWindowsLabel}
              source={deliveryWindowsSource}
              initialData={deliveryWindows}
              isDisabled={isDeliveryWindowsDisabled}
              testId={CatalogProductsTestIds.DETAILS_NAVIGATION_DELIVERY_WINDOWS}
              onConfirm={submitDeliveryWindows}
              getOptionLabel={(deliveryWindow) =>
                deliveryWindow.name ?? deliveryWindow.code ?? deliveryWindow.id
              }
            />
          }
        />
      </Stack>
    </ObjectScreen.Section>
  );
};

export default CatalogNavigationSection;
